import React from 'react';
import LayersAndResolutions from 'data/layers/LayersAndResolutions.json';

const DiscreteColorLegend = ({ colors }) => {

    // We calculate the percentage for every step, for every color.
    const percentagePerStep = 100 / colors.length;
    
    // We obtain and format the colors.
    const discreteColors = colors.map((color, index) => `${color.color} ${index * percentagePerStep}%, ${color.color} ${(index + 1) * percentagePerStep}%`);

    // And return the bar with discrete colors.
    return (
        <div style={{ padding: '20px 10px', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{
                background: `linear-gradient(to left, ${discreteColors.join(',')}`, // Horizontal gradient.
                height: '30px',
                width: '300px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                position: 'relative',
                marginBottom: '20px'
            }}>

                {
                    // We add small arrows, alternating below and above the gradient.
                    colors.slice().reverse().map((item, index) => {
                        
                        // We calculate the position (in percentages) of the current arrow by getting the average between the current and next step.
                        const position = (percentagePerStep * index + percentagePerStep * (index + 1)) / 2; 

                        return (
                            <span key={index} style={{
                                position: 'absolute',
                                left: `${position}%`,
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '10px',
                                whiteSpace: 'nowrap',
                                transform: 'translateX(-50%)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: index % 2 === 0 ? '-40px' : '5px',
                            }}>
                                <span style={{
                                    width: 0,
                                    height: 0,
                                    borderLeft: '5px solid transparent',
                                    borderRight: '5px solid transparent',
                                    borderTop: index % 2 === 0 ? '5px solid black' : 'none',  // Arrow aiming downwards, on top of the gradient.
                                    borderBottom: index % 2 === 0 ? 'none' : '5px solid black',  // Arrow aiming upwards, below the gradient.
                                    marginBottom: index % 2 === 0 ? '-30px' : '5px',  // Reduced the space below the inferior arrows.
                                    marginTop: index % 2 === 0 ? '39px' : '20px',
                                }}></span>
                                {item.value}
                            </span>
                        );
                    })
                }
            </div>
        </div>
    )
}

export default DiscreteColorLegend